import { NgModule } from '@angular/core';
import { OptionModule } from '../abstract/option.module';
import { OptionNumberComponent } from './option-number.component';
import { DndModule } from 'ngx-drag-drop';

@NgModule({
  imports: [
    OptionModule,
    DndModule,
  ],
  declarations: [OptionNumberComponent],
  exports:[OptionNumberComponent],
})
export class OptionNumberModule { }
